export const PLAYER_SETUP_STEPS: readonly { title: string; detail: string; image?: string; alt: string }[] = [
  {
    title: 'Ponete la banda del pecho',
    detail: 'Humedecé los electrodos de la banda, encastrá el módulo Polar en sus dos broches y ajustala centrada sobre el pecho, justo debajo de los pectorales, contra la piel.',
    image: '/onboarding/polar-h10-cutout.png',
    alt: 'Banda de pecho con el sensor Polar H10',
  },
  {
    title: 'Agarrá el control con la mano derecha',
    detail: 'Usá el dedo índice para el gatillo.',
    alt: 'Mano derecha sosteniendo el control y apretando el gatillo con el índice',
  },
  {
    title: 'Pedile el visor al staff y ponételo',
    detail:
      'Con la banda ya puesta, entrá con los mismos 6 dígitos que usaste en esta tablet y tocá “Comenzar en VR”.',
    image: '/onboarding/quest-headset-cutout.png',
    alt: 'Visor Meta Quest con sus correas de sujeción',
  },
]
